"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineFMSModules = void 0;
var otp_banner_module_1 = require("./otp-banner/otp-banner.module");
var qrcode_redirect_module_1 = require("./qrcode-redirect/qrcode-redirect.module");
exports.OfflineFMSModules = {
    'offline-redirect': { class: qrcode_redirect_module_1.OfflineQrcodeRedirectModule },
    'offline-otp-banner': {
        class: otp_banner_module_1.OfflineOTPBannerModule,
        references: {
            timeleft: { description: 'shows the left time til when the token is invalid', uid: 'timeleft', dontRemoveFromDom: true },
        },
    },
};
